module.exports = __webpack_public_path__ + "img/1590882431.ae5bb47c.jpg";